import { createSlice } from "@reduxjs/toolkit";
import config from "../config";
import {
  reducerLoadInitialBasicController,
  reducerLoadInitialBusinessController,
  reducerLoadInitialClaimedController,
  reducerLoadInitialResultController,
  reducerLoadInitialRewardController,
  reducerLoadInitialStepController,
  reducerLoadInitialUserController,
} from "../controllers/reducerController.js";

const initialState = {
  user: reducerLoadInitialUserController() || null,
  step: reducerLoadInitialStepController() || 1,
  basic: reducerLoadInitialBasicController() || {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  },
  business: reducerLoadInitialBusinessController() || {
    name: "",
    online: undefined,
    description: "",
    interest: "",
    challenge: "",
  },
  result: reducerLoadInitialResultController() || {
    id: "",
    reward: "",
    rewardCode: "",
  },
  reward: reducerLoadInitialRewardController() || {},
  claimed: reducerLoadInitialClaimedController() || {},
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem(
          config.localStorage.user,
          JSON.stringify(action.payload)
        );
      } else {
        localStorage.removeItem(config.localStorage.user);
      }
    },
    logout: (state, action) => {
      state.user = null;
      localStorage.removeItem(config.localStorage.user);
    },
    setStep: (state, action) => {
      state.step = action.payload;
      localStorage.setItem(
        config.localStorage.step,
        JSON.stringify(state.step)
      );
    },
    setBasic: (state, action) => {
      state.basic = {
        ...state.basic,
        [action.payload?.field]: action?.payload?.value,
      };
      localStorage.setItem(
        config.localStorage.basic,
        JSON.stringify(state.basic)
      );
    },
    setBusiness: (state, action) => {
      state.business = {
        ...state.business,
        [action.payload?.field]: action?.payload?.value,
      };
      localStorage.setItem(
        config.localStorage.business,
        JSON.stringify(state.business)
      );
    },
    setResult: (state, action) => {
      state.result = action?.payload;
      localStorage.setItem(
        config.localStorage.result,
        JSON.stringify(action?.payload)
      );
    },
    setReward: (state, action) => {
      state.reward = action?.payload;
      localStorage.setItem(
        config.localStorage.reward,
        JSON.stringify(action?.payload)
      );
    },
    setClaimed: (state, action) => {
      state.claimed = action?.payload;
      localStorage.setItem(
        config.localStorage.claimed,
        JSON.stringify(action?.payload)
      );
    },
  },
});

export const {
  setUser,
  logout,
  setStep,
  setBusiness,
  setBasic,
  setResult,
  setReward,
  setClaimed,
} = userSlice.actions;
export default userSlice.reducer;
